import React from 'react';
import {array, func, string} from 'prop-types';
import styles from './MobileNavDrilldownList.scss';

/**
 * Checks if it's possible to format numbers using the new-ish Intl API that browsers provide. In the future we might
 * have a polyfill. This isn't and should not be rendered on the server, so there's no worries of content mismatch.
 */
function formatNumber(number) {
    if (typeof Intl !== 'undefined' && typeof number === 'number') {
        return new Intl.NumberFormat().format(number);
    } else {
        return number;
    }
}

function MobileNavDrilldownList(props) {
    return (
        <div>
            {props.items.map(item => {
                const formattedCount = formatNumber(item.count);
                const {name, url} = item;
                const path = item.path || url;
                return (
                    <div onClick={() => props.onItemClick({path, name})} className={styles.item} key={item.name}>
                        <span>{item.name}</span>
                        {!!item.count && <span className={styles.count}>{formattedCount}</span>}
                    </div>
                );
            })}
        </div>
    );
}

MobileNavDrilldownList.propTypes = {
    items: array.isRequired,
    onItemClick: func,
    name: string
};

export default MobileNavDrilldownList;



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldownList.jsx